import corona from '@music/corona-web-sdk-public'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { addGlobalUncaughtErrorHandler } from 'qiankun'
dayjs.locale('zh-cn')
/**
 * 文档参考：https://febase-doc.st.netease.com/docs/error-monitor/web
 * 监控平台：https://music-corona.hz.netease.com/project/6409/issue/list
 */

export const coronaMonitor = corona({
	id: 6409, // 必传，配置应用 id
	env: process.env.HOST_ENV, //process.env.HOST_ENV, // 必传，配置当前环境，支持的环境类型见下文文档部分
	debug: false, // 可选，是否上传本地开发环境错误的开关，默认 false，即不上传（主动上报的日志依然会上传）
})
// 添加全局的未捕获异常处理器。
addGlobalUncaughtErrorHandler(() => {})
